/* CarbonPhone – Smarte Empfehlungen, Zubehör-Addons, Bewertung (Test-Theme) */
const DEVICE_WORDS = ['iphone', 'galaxy', 'pixel', 'ipad', 'watch', 'lightning', 'xiaomi', 'redmi', 'macbook', 'tab '];
const ACC_TYPES = ['Schutzfolien', 'Smartphone-Hüllen', 'Linsenschutz', 'Tablet-Cover', 'Smartwatch Armbänder', 'S Pen', 'Ladegeräte', 'USB-Kabel', 'Akkus', 'Handyhalterung', 'Keyboard'];
const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export function money(cents) {
  return '€' + (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/* "Apple iPhone 15" -> "iPhone 15", "Samsung Galaxy S24 FE 5G" -> "Galaxy S24 FE", "Xiaomi 15" -> "Xiaomi 15" */
export function modelKey(title, vendor) {
  let t = title.trim();
  if (vendor && t.toLowerCase().startsWith(vendor.toLowerCase() + ' ')) t = t.slice(vendor.length + 1);
  const w = t.split(/\s+/), out = [];
  for (let i = 0; i < w.length && out.length < 4; i++) {
    out.push(w[i]);
    if (/\d/.test(w[i])) {
      const nx = w[i + 1] || '';
      if (/^(Pro|Plus|Max|Ultra|Mini|FE|Lite|XL)$/i.test(nx)) {
        out.push(nx);
        if (/^(Max|XL)$/i.test(w[i + 2] || '')) out.push(w[i + 2]);
      }
      break;
    }
  }
  let key = out.join(' ');
  if (!/[a-zA-Z]/.test(key) && vendor) key = vendor + ' ' + key;
  return key;
}

/* ---------- Exakter Modellabgleich ----------
   Vereinheitlicht Schreibweisen, damit "Galaxy S24+" = "Galaxy S24 Plus" ist,
   aber niemals = "Galaxy S24". */
const SUFFIX = new Set(['pro', 'plus', 'max', 'ultra', 'mini', 'fe', 'lite', 'xl', 'edge', 'neo', 'serie', 'series', 'reihe', 'modelle', 'fold', 'flip', 'slim', 'air', 'e', 'a', 's', 'r', 'c']);
export function normModel(s) {
  let t = ' ' + String(s).toLowerCase()
    .replace(/\(.*?\)/g, ' ')
    .replace(/\+/g, ' plus ')
    .replace(/promax/g, 'pro max')
    .replace(/(\d)(fe|plus|pro|max|ultra|mini|lite|xl)\b/g, '$1 $2')
    .replace(/[–—\-_,;:|/·&"„“”]/g, ' ') + ' ';
  t = t.replace(/ (apple|samsung|google|5g|4g|lte|wifi|wi fi|cellular|gps) /g, ' ').replace(/ (apple|samsung|google|5g|4g|lte|wifi|cellular|gps) /g, ' ');
  t = t.replace(/\s+/g, ' ').trim();
  if (/^(z (flip|fold)|tab [a-z]?\d)/.test(t)) t = 'galaxy ' + t;
  return t;
}

/* Passt ein Optionswert wie "Galaxy S24 / Galaxy S24+ (3 Linsen)" exakt zum Modell?
   Jeder Teil muss nach Vereinheitlichung genau dem Modell entsprechen. */
export function valueFitsModel(value, key) {
  const k = normModel(key);
  if (!k) return false;
  const parts = String(value).replace(/\(.*?\)/g, ' ').split(/\s*(?:\/|,|&|\||\bund\b)\s*/i).map(normModel).filter(Boolean);
  if (!parts.length) return false;
  const words = parts[0].split(' ');
  const di = words.findIndex((x) => /\d/.test(x));
  const family = di > 0 ? words.slice(0, di).join(' ') : '';
  const head = di >= 0 ? words.slice(0, di + 1).join(' ') : '';
  return parts.some((p, i) => {
    let tok = p;
    if (i > 0) {
      if (!/\d/.test(tok) && head) tok = head + ' ' + tok; // "iPhone 15 Pro / Pro Max"
      else if (family && /\d/.test(tok.split(' ')[0]) && !tok.startsWith(family + ' ')) tok = family + ' ' + tok; // "Galaxy S24 / S24+"
    }
    return tok === k;
  });
}

/* Nennt ein Titel das Modell exakt? "für Galaxy S24" ja, "für Galaxy S24+", "S24 Ultra" oder "S24 Serie" nein. */
export function fitsModel(title, key) {
  const k = normModel(key);
  if (!k) return false;
  // "iPhone 14 Plus / 13 Pro Max" -> "iPhone 14 Plus / iPhone 13 Pro Max"
  const parts = String(title).replace(/\(.*?\)/g, ' ').split(/\s*\/\s*/);
  const fam = (normModel(parts[0]).match(/(iphone|galaxy|pixel|ipad|xperia|redmi|honor|oneplus)(?!.*(iphone|galaxy|pixel|ipad|xperia|redmi|honor|oneplus))/) || [])[1];
  const t = ' ' + parts.map((p, i) => {
    const n = normModel(p);
    return i > 0 && fam && /^\d/.test(n) ? fam + ' ' + n : n;
  }).join(' ') + ' ';
  const re = new RegExp(' ' + esc(k) + ' ([^ ]*)', 'g');
  let m;
  while ((m = re.exec(t))) {
    if (!SUFFIX.has(m[1])) return true;
    re.lastIndex = m.index + 1;
  }
  return false;
}

/* Twelve South Ladegeraete (ButterFly): fuer iPhone, Apple Watch und kabellos ladefaehige Android-Handys */
const TS_RE = /twelve south|butterfly/i;
/* Android-Handys mit kabellosem Laden (Qi/Qi2) – Einsteigermodelle ohne kabelloses Laden bleiben aussen vor */
const WIRELESS_RE = /pixel\s*(?:[789]|1\d)(?!\d)|pixel (?:fold|10|11)|galaxy (?:s\d{2}(?! fe)|s\d{2} fe|z |note)|z (?:flip|fold)|xiaomi (?:1[2-9]|\d{2}t pro)(?!\d)|xiaomi \d{2} ultra|honor magic\s*\d(?! lite)|oneplus (?:\d{1,2}(?!\w)|open)|nothing phone \(\d\)|xperia (?:1|5)\b|fairphone [56]|motorola edge (?:\d{2}|plus) (?:pro|ultra)/i;
/* Zubehoer fuer ein bestimmtes Oekosystem: MagSafe/Qi2-Halter nur fuers iPhone, Lightning nur bis iPhone 14 */
export function ecosystemOk(title, key) {
  const t = String(title).toLowerCase(), k = String(key).toLowerCase();
  if (TS_RE.test(t)) return !/watch/.test(k) || (!/galaxy|pixel|huawei|xiaomi|amazfit|garmin/.test(k));
  if (/magsafe|qi2/.test(t) && !/iphone/.test(k) && !(/watch/.test(k) && !/galaxy/.test(k) && /watch/.test(t))) return false;
  if (/lightning/.test(t)) {
    const m = k.match(/iphone\s*(\d+)/);
    if (!((m && +m[1] < 15) || /iphone\s*(se|x)/.test(k))) return false;
  }
  return true;
}

function isUniversal(cardTitle, productTitle) {
  const ct = cardTitle.toLowerCase(), pt = productTitle.toLowerCase();
  return !DEVICE_WORDS.some((w) => ct.includes(w) && !pt.includes(w.trim()));
}

const typeParams = (types) => types.map((t) => 'filter.p.product_type=' + encodeURIComponent(t)).join('&');

async function fetchCards(url) {
  try {
    const sep = url.includes('?') ? '&' : '?';
    const html = await fetch(url + sep + 'section_id=cp-card-strip', { priority: 'low' }).then((r) => (r.ok ? r.text() : ''));
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return [...doc.querySelectorAll('product-card')].map((el) => ({
      el,
      handle: el.getAttribute('handle'),
      title: (el.querySelector('.product-card__title')?.textContent || '').trim()
    }));
  } catch (e) {
    return [];
  }
}

const prodCache = new Map();
export function productJson(handle) {
  if (!prodCache.has(handle)) prodCache.set(handle, fetch(`/products/${handle}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null));
  return prodCache.get(handle);
}

/* ---------- Cross-Selling: Armbänder, Twelve South, Backbone, Kopfhörer ----------
   Regeln je Gerät; Rang = Reihenfolge (kleiner = früher). -1 = passt nicht. */
const EXTRA_TYPES = ['Smartwatch Armbänder', 'Ladegeräte', 'Gaming', 'Kopfhörer'];
const BASIC_PHONE_RE = /doro|emporia|beafon|onetouch|tastenhandy|klapphandy|seniorenhandy|nokia (?:2\d{3}|3310|105|110|130|150|215|225)/i;
export function deviceInfo(title, type, price) {
  const t = String(title).toLowerCase(), ty = String(type || '');
  const i = { kind: 'other', usbc: false, fold: /fold|flip|razr/.test(t), apple: /apple|iphone|ipad|macbook/.test(t), group: '', ultra: /ultra/.test(t), premium: false };
  if (/apple watch/.test(t)) {
    i.kind = 'apple-watch';
    const mm = parseInt((t.match(/(\d{2})\s?mm/) || [])[1], 10);
    if (mm) i.group = mm <= 41 || (mm === 42 && /series\s*(1[0-9])/.test(t)) ? 'small' : 'large';
  } else if (/galaxy watch/.test(t)) i.kind = 'galaxy-watch';
  else if (ty === 'Smartwatches') i.kind = 'watch';
  else if (ty === 'Notebooks' || /macbook|notebook|laptop/.test(t)) i.kind = 'laptop';
  else if (ty === 'Tablets' || /ipad|galaxy tab|\btab\b/.test(t)) i.kind = 'tablet';
  else if (/iphone/.test(t)) {
    i.kind = 'iphone';
    const n = parseInt((t.match(/iphone\s*(\d+)/) || [])[1], 10);
    i.usbc = n >= 15;
  } else if (ty === 'Smartphones' || DEVICE_RE.test(t)) {
    i.kind = BASIC_PHONE_RE.test(t) ? 'basic-phone' : 'phone';
    i.usbc = i.kind === 'phone';
  }
  i.wireless = i.kind === 'iphone' || (i.kind === 'phone' && WIRELESS_RE.test(t) && !/\b6a\b|pixel\s*[345]/.test(t));
  /* Teure Geraete: iPad, MacBook, Pro Max / Ultra / Fold oder ab ca. 900 EUR (keine Uhren) */
  i.premium = !/watch/.test(i.kind) && (/ipad|macbook/.test(t) || /pro max|ultra|z fold/.test(t) || (price || 0) >= 90000);
  return i;
}
const bandGroup = (ct) => {
  const m = ct.match(/((?:\d{2}\s*\/\s*)*\d{2})\s?mm/);
  if (!m) return '';
  const n = m[1].split('/').map((x) => parseInt(x, 10));
  if (n.some((x) => x >= 44)) return 'large';
  if (n.some((x) => x <= 41)) return 'small';
  return '';
};
export function extraRank(cardTitle, info) {
  const ct = String(cardTitle).toLowerCase();
  const phone = info.kind === 'iphone' || info.kind === 'phone';
  if (/armband|strap|loop\b/.test(ct)) {
    if (info.kind === 'apple-watch' && /apple watch/.test(ct)) {
      const g = bandGroup(ct);
      return g && (!info.group || g === info.group) ? 1 : -1;
    }
    if (info.kind === 'galaxy-watch' && !info.ultra && /samsung|galaxy/.test(ct)) return 1;
    return -1;
  }
  if (TS_RE.test(ct)) return info.kind === 'iphone' || info.kind === 'apple-watch' ? 0 : info.wireless ? 1.5 : -1;
  if (/apple watch/.test(ct)) return info.kind === 'apple-watch' ? 2 : -1;
  if (/backbone/.test(ct)) return phone && info.usbc && !info.fold ? 2 : -1;
  if (/airpods|kopfh|pods|buds|headphone|earbud/.test(ct)) {
    if (info.kind === 'basic-phone' || info.kind === 'other') return -1;
    if (/airpods max/.test(ct) && !info.premium) return -1;
    const appleItem = /airpods|apple/.test(ct);
    return 4 + (appleItem && !info.apple ? 2 : 0) + Math.random();
  }
  if (/kabellos|wireless|\bqi\b|magsafe/.test(ct)) return info.wireless ? 5 : -1;
  if (/lade|charger|netzteil|kabel/.test(ct)) return phone || info.kind === 'tablet' || info.kind === 'laptop' ? 6 : -1;
  return -1;
}
async function extrasFor(p) {
  const info = deviceInfo(p.title, p.type, p.price);
  if (info.kind === 'other') return [];
  const u = `/collections/all?filter.v.availability=1&${typeParams(EXTRA_TYPES)}&sort_by=best-selling`;
  return (await fetchCards(u))
    .map((c) => Object.assign(c, { rank: extraRank(c.title, info), extra: true }))
    .filter((c) => c.rank >= 0)
    .sort((a, b) => a.rank - b.rank);
}

/* Liefert Kandidaten in der gewünschten Reihenfolge */
export async function* candidates(mode, p) {
  const key = modelKey(p.title, p.vendor);
  if (mode === 'accessories') {
    const info = deviceInfo(p.title, p.type, p.price);
    const extrasP = extrasFor(p);
    const q = `/search?q=${encodeURIComponent(key)}&type=product&options[prefix]=last&filter.v.availability=1&${typeParams(ACC_TYPES)}`;
    const own = [];
    for (const c of await fetchCards(q)) {
      // Nur zeigen, wenn genau dieses Modell lieferbar ist – und direkt auf die passende Variante verlinken
      const prod = await productJson(c.handle);
      const a = prod && analyseAddon(prod, key);
      if (!a) continue;
      if (a.fit) c.el.querySelectorAll('a[href*="/products/"]').forEach((l) => {
        const u = new URL(l.getAttribute('href'), location.origin);
        u.searchParams.set('variant', a.def.id);
        l.setAttribute('href', u.pathname + u.search);
      });
      own.push(c);
    }
    const addons = p.ctx === 'addons';
    const extras = (await extrasP).filter((c) => !(addons && /belkin/i.test(c.title)));
    const ts = extras.filter((c) => TS_RE.test(c.title));
    const top = extras.filter((c) => c.rank < 4 && !(addons && TS_RE.test(c.title))), rest = extras.filter((c) => c.rank >= 4);
    if (addons) yield* ts;
    yield* own.slice(0, 2);
    yield* top;
    yield* own.slice(2);
    yield* rest;
    const u = `/collections/all?filter.v.availability=1&${typeParams(['Ladegeräte', 'USB-Kabel'])}&sort_by=best-selling`;
    if (!['iphone', 'phone', 'tablet', 'laptop'].includes(info.kind)) return;
    for (const c of await fetchCards(u)) {
      if (!isUniversal(c.title, p.title) || !ecosystemOk(c.title, key)) continue;
      if (TS_RE.test(c.title) && extraRank(c.title, info) < 0) continue;
      if (p.ctx === 'addons' && /belkin/i.test(c.title)) continue;
      if (/kabellos|wireless|\bqi\b|magsafe/i.test(c.title) && !info.wireless) continue;
      yield c;
    }
  } else {
    const lo = Math.floor((p.price / 100) * 0.6), hi = Math.ceil((p.price / 100) * 1.6);
    const base = `/collections/all?filter.v.availability=1&filter.p.product_type=${encodeURIComponent(p.type)}&filter.v.price.gte=${lo}&filter.v.price.lte=${hi}&sort_by=best-selling`;
    for (const c of await fetchCards(base + '&filter.p.vendor=' + encodeURIComponent(p.vendor))) yield c;
    for (const c of await fetchCards(base)) yield c;
  }
}

/* ---------- Empfehlungs-Sektionen auffüllen ---------- */
class CpRecoFill extends HTMLElement {
  async connectedCallback() {
    const d = this.dataset, section = this.closest('.shopify-section');
    const list = section.querySelector('[data-cp-reco-list]');
    const seen = new Set(d.handles.split('|').filter(Boolean));
    const max = parseInt(d.max, 10) || 8;
    let count = list.querySelectorAll('product-card').length;
    const p = { title: d.title, vendor: d.vendor, type: d.type, price: parseInt(d.price, 10) };
    for await (const c of candidates(d.mode, p)) {
      if (count >= max) break;
      if (!c.handle || seen.has(c.handle)) continue;
      seen.add(c.handle);
      list.appendChild(document.importNode(c.el, true));
      count++;
    }
    if (count === 0) section.style.display = 'none';
    else section.querySelector('scroll-carousel')?.classList.toggle('is-scrollable', count > (parseInt(d.perRow, 10) || 5));
  }
}
if (!customElements.get('cp-reco-fill')) customElements.define('cp-reco-fill', CpRecoFill);

/* ---------- Zubehör-Addons vor dem Warenkorb ---------- */
const DEVICE_RE = /(iphone|galaxy|pixel|ipad|apple watch|watch\s?\d|redmi|xiaomi|macbook|honor|oneplus|nothing phone|motorola|razr|fairphone|xperia|huawei|oppo|z flip|z fold|\btab\b|\bs\d{2}\b)/i;
const MODEL_OPT_RE = /^(model|modell|gerät|geraet|kompatib|passend|für|fuer|device)/i;
/* Zubehoer, das nur zum richtigen Modell passt (Schutz, Huellen) */
const FIT_TYPES = ['Schutzfolien', 'Smartphone-Hüllen', 'Linsenschutz', 'Tablet-Cover'];
/* Schutz-Zubehoer fuers Smartphone – erscheint im Bundle-Pop-up statt in der Box */
export const PROTECT_TYPES = ['Schutzfolien', 'Smartphone-Hüllen', 'Linsenschutz'];
const CHECK_SVG = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

/* Analysiert ein Zubehoerprodukt (/products/x.js) fuer das Geraet "key".
   Liefert null, wenn es fuer genau dieses Modell nichts Lieferbares gibt. */
export function analyseAddon(prod, key, extra) {
  if (!ecosystemOk(prod.title, key)) return null;
  if (extra) {
    const names0 = prod.options.map((o) => (typeof o === 'string' ? o : o.name));
    const vars0 = prod.variants.filter((v) => v.available);
    if (!vars0.length) return null;
    const choices0 = names0.map((n, i) => ({ name: n, idx: i, values: [...new Set(vars0.map((v) => v.options[i]))] })).filter((c) => c.values.length > 1);
    const z0 = names0.findIndex((n) => /^zustand$/i.test(n));
    const def0 = (z0 >= 0 && vars0.find((v) => v.options[z0] === 'Neu')) || vars0[0];
    return { vars: vars0, choices: choices0, def: def0, fit: false, zIdx: z0, modelLabel: '' };
  }
  const names = prod.options.map((o) => (typeof o === 'string' ? o : o.name));
  const values = prod.options.map((o, i) => (typeof o === 'string' ? [...new Set(prod.variants.map((v) => v.options[i]))] : o.values));
  const modelIdx = names.findIndex((n, i) => MODEL_OPT_RE.test(n) || values[i].some((v) => DEVICE_RE.test(v)));
  let vars = prod.variants.filter((v) => v.available);
  let fit = false;
  const needsFit = FIT_TYPES.includes(prod.type) || DEVICE_RE.test(prod.title);
  if (modelIdx >= 0 && values[modelIdx].some((v) => DEVICE_RE.test(v))) {
    // Modell-Option vorhanden: nur Varianten, deren Modell exakt passt
    vars = vars.filter((v) => valueFitsModel(v.options[modelIdx], key));
    if (!vars.length) return null;
    fit = true;
  } else if (needsFit) {
    // Keine Modell-Option: der Titel muss genau dieses Modell nennen ("Serie" reicht nicht)
    if (!fitsModel(prod.title, key)) return null;
    fit = true;
  }
  if (!vars.length) return null;
  // Waehlbare Optionen (ohne Modell), nur Werte mit lieferbaren Varianten
  const choices = names.map((n, i) => ({ name: n, idx: i, values: [...new Set(vars.map((v) => v.options[i]))] }))
    .filter((c) => c.idx !== modelIdx && c.values.length > 1);
  // Standard: Zustand "Neu" bevorzugen, sonst erste lieferbare Variante
  const zIdx = names.findIndex((n) => /^zustand$/i.test(n));
  const def = (zIdx >= 0 && vars.find((v) => v.options[zIdx] === 'Neu')) || vars[0];
  return { vars, choices, def, fit, zIdx, modelLabel: fit ? key : '' };
}

class CpAddons extends HTMLElement {
  async connectedCallback() {
    const d = this.dataset, ul = this.querySelector('ul');
    const max = 3, key = modelKey(d.title, d.vendor);
    // Ist das Bundle-Pop-up aktiv (nur Smartphones), kommen Displayschutz, Huellen und Linsenschutz nur dort – keine Ueberschneidung
    const noProtect = !!document.querySelector('cp-bundle');
    const seen = new Set([d.handle]);
    const handles = (d.handles || '').split('|').filter(Boolean);
    const tryAdd = async (handle, extra) => {
      if (ul.children.length >= max || !handle || seen.has(handle)) return;
      seen.add(handle);
      const prod = await productJson(handle);
      if (prod && noProtect && PROTECT_TYPES.includes(prod.type)) return;
      const a = prod && analyseAddon(prod, key, extra);
      if (a && ul.children.length < max) ul.appendChild(this.renderItem(prod, a));
    };
    for (const h of handles) await tryAdd(h);
    if (ul.children.length < max) {
      for await (const c of candidates('accessories', { title: d.title, vendor: d.vendor, type: d.type, price: parseInt(d.price, 10) || 0, ctx: 'addons' })) {
        if (ul.children.length >= max) break;
        await tryAdd(c.handle, c.extra);
      }
    }
    if (ul.children.length === 0) { this.hidden = true; return; }
    this.hidden = false;

    document.addEventListener('variant:add', async (e) => {
      const items = e.detail?.items || [];
      if (!items.some((i) => String(i.product_id) === d.productId)) return;
      const checked = [...this.querySelectorAll('input[type="checkbox"]:checked')];
      if (!checked.length) return;
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: checked.map((i) => ({ id: parseInt(i.value, 10), quantity: 1 })) })
      });
      checked.forEach((i) => (i.checked = false));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  renderItem(prod, a) {
    const li = document.createElement('li');
    li.dataset.handle = prod.handle;
    const img = (v) => {
      const src = (v.featured_image && v.featured_image.src) || prod.featured_image || '';
      return src ? `${src}${src.includes('?') ? '&' : '?'}width=120` : '';
    };
    li.innerHTML = `<label class="cp-addons__item"><input type="checkbox"><span class="cp-addons__img"><img alt="" loading="lazy" width="44" height="44"></span><span class="cp-addons__info"><span class="cp-addons__name"></span><span class="cp-addons__fit" hidden>${CHECK_SVG}<span></span></span><span class="cp-addons__meta" hidden></span></span><span class="cp-addons__price"></span></label>`;
    li.querySelector('.cp-addons__name').textContent = prod.title;
    if (a.fit && a.modelLabel) {
      const f = li.querySelector('.cp-addons__fit');
      f.lastElementChild.textContent = 'passend für ' + a.modelLabel;
      f.hidden = false;
    }
    const cb = li.querySelector('input');
    const imgEl = li.querySelector('img');
    const priceEl = li.querySelector('.cp-addons__price');
    const metaEl = li.querySelector('.cp-addons__meta');
    const zChoice = a.choices.some((c) => c.idx === a.zIdx);
    const apply = (v) => {
      cb.value = v.id;
      const z = a.zIdx >= 0 ? v.options[a.zIdx] : '';
      metaEl.hidden = !(z && z !== 'Neu' && !zChoice);
      metaEl.textContent = 'Zustand: ' + z;
      priceEl.textContent = '+ ' + money(v.price);
      const s = img(v);
      if (s) imgEl.src = s;
    };
    apply(a.def);
    if (a.choices.length) {
      const box = document.createElement('div');
      box.className = 'cp-addons__opts';
      const selects = a.choices.map((c) => {
        const wrap = document.createElement('label');
        wrap.className = 'cp-addons__opt';
        const sel = document.createElement('select');
        sel.dataset.idx = c.idx;
        sel.setAttribute('aria-label', c.name + ' für ' + prod.title);
        c.values.forEach((val) => { const o = document.createElement('option'); o.value = o.textContent = val; sel.appendChild(o); });
        sel.value = a.def.options[c.idx];
        const lab = document.createElement('span'); lab.textContent = c.name;
        wrap.append(lab, sel);
        box.appendChild(wrap);
        return sel;
      });
      const onChange = (changed) => {
        const want = Object.fromEntries(selects.map((s) => [s.dataset.idx, s.value]));
        let v = a.vars.find((x) => selects.every((s) => x.options[s.dataset.idx] === want[s.dataset.idx]));
        if (!v) v = a.vars.find((x) => x.options[changed.dataset.idx] === changed.value) || a.def;
        selects.forEach((s) => { s.value = v.options[s.dataset.idx]; });
        apply(v);
        cb.checked = true;
      };
      selects.forEach((s) => s.addEventListener('change', () => onChange(s)));
      li.appendChild(box);
    }
    return li;
  }
}
if (!customElements.get('cp-addons')) customElements.define('cp-addons', CpAddons);

/* ---------- Trustami-Bewertung in der Buy-Box ---------- */
class CpRating extends HTMLElement {
  async connectedCallback() {
    let data = null;
    try { data = JSON.parse(sessionStorage.getItem('cp-trustami') || 'null'); } catch (e) {}
    if (!data) {
      try {
        const t = await fetch(this.dataset.src).then((r) => r.text());
        const v = t.match(/ratingValue\\?">([\d.]+)/), c = t.match(/reviewCount\\?">(\d+)/);
        if (v && c) data = { v: parseFloat(v[1]), c: parseInt(c[1], 10) };
        try { sessionStorage.setItem('cp-trustami', JSON.stringify(data)); } catch (e) {}
      } catch (e) {}
    }
    if (!data) return;
    this.querySelector('[data-v]').textContent = data.v.toLocaleString('de-DE', { minimumFractionDigits: 2 });
    this.querySelector('[data-c]').textContent = data.c.toLocaleString('de-DE');
    this.hidden = false;
  }
}
if (!customElements.get('cp-rating')) customElements.define('cp-rating', CpRating);
